import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  getWorkers,
  createWorker,
  deleteWorker,
  updateWorker,
  statusRefresh
} from "../../Redux/actions/workers";
import EmptyScreen from "../../Assets/Empty-Screen.png";
import loader from "../../Assets/loaderTransaparent.gif";
import SettingsIcon from "../../Assets/noun_Settings_2434659@2x.png";
import CustomModal from "../../UtilityComponents/customModal";
import DeleteWorker from "./deleteWorker.js";
import stringToDate from "../../Utilities/stringToDate";
import { addNotification } from "../../Utilities/notifications";
import { checkPayment } from "../../Redux/actions/billingPayment";
import SettingsWorker from "./SettingsWorker";

function Workers(props) {
  let { user } = props;
  let [worker, setWorker] = useState({});
  const [processing, setProcessing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [workers, setWorkers] = useState([]);
  const [modal, setModal] = useState(false);
  const [action, setAction] = useState("");
  const [refresh_css , setRefreshCSS] = useState(false);
  const [settings, setSettingsView] = useState(false);
  // const [dropdownOpen, setDropdownOpen] = useState(false);

  // const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const toggle = (obj, action) => {
    if (obj && action) {
      if (action === "start" && !obj.active) {
        addNotification({
          title: "Techforce.ai",
          message: `Your E-Worker Machine limit (720 hrs) exceeded for this month, Please upgrade to start.`,
          type: "info",
        });
        props.history.push("/settings/billing");
        return;
      }
      setWorker(obj);
      setAction(action);
    }
    setModal(!modal);
  };

  const settingsView =(obj, value)=>{
    if(obj)  
      setWorker(obj);
    setSettingsView(!settings);
  }


  useEffect(() => {
    document.title = "E-Worker Machines | E-Manager Console Webapp | Techforce";
    const fetchData = async () => {
      reloadProcess();
    };
    fetchData();
    window.EventEmitter.on("workerreload" ,()=>{
      reloadProcess();
    });
  }, []);

  const handleCreate = async () => {
    if (user.subscription_id === 1 ) {
      let obj = await checkPayment()
      let {payment,pause_sub} = obj.data
      if (payment === true) {
       if(pause_sub !=='void'){
        setProcessing(true);
        let status = await createWorker();
        if(status  == 402){
          props.history.push("/settings/billing");
        }
        reloadProcess();
        setProcessing(false);
        }else{
          addNotification({
            title: "Techforce.ai",
            message: "Your Subscription has been paused",
            type: "info",
          });
          props.history.push("/settings/billing");
        }
      }else if(user.check_plan  == "enterprise" ) {
         await createWorker();
      }else {
        addNotification({
          title: "Techforce.ai",
          message: "Please upgrade your plan to create new worker",
          type: "info",
        });
        props.history.push("/settings/billing");
      }
    } else {
      setProcessing(true);
      let status = await createWorker();
      if(status  == 402){
        props.history.push("/settings/billing");
      }
      reloadProcess();
      setProcessing(false);
    }
  };


  const reloadProcess = async () => {
    setLoading(true);
    let data = await getWorkers();
    if (data) {
      let workers = data.map((worker) => {
        let {
          eworker,
          eworker_uptime,
          total_uptime,
          cumulative_uptime,
        } = worker;
        if (eworker) {
          let percentage = Math.floor(
            ((total_uptime + cumulative_uptime) * 100) /
              parseInt(eworker_uptime)
          );
          return { ...worker, percentage, dropdownOpen: false };
        } else {
          return { ...worker, dropdownOpen: false };
        }
      });
      setWorkers(workers);
    }
    setLoading(false);
  };

  const refresh = async()=>{
    setRefreshCSS(true);
    let data = await statusRefresh(workers? workers.map(obj => obj.worker_id):[]);
    if (data) {
      setWorkers(data);
    }
    setRefreshCSS(false);
  }

  const handleDropdownOpen = async (obj) => {
    let worker_index = workers.findIndex(
      (worker) => worker.worker_id === obj.worker_id
    );
    if (worker_index >= 0) {
      if (obj.dropdownOpen) {
        workers[worker_index]["dropdownOpen"] = false;
      } else {
        workers[worker_index]["dropdownOpen"] = true;
      }
    }
    setWorkers([...workers]);
  };

  const handleDelete = async () => {
    toggle();
    let machines = workers.map((obj) => {
      if (worker.worker_id === obj.worker_id) {
        return { ...obj, loading: true };
      } else {
        return obj;
      }
    });
    setWorkers(machines);

    if (user.organization_id) {
      if (user.role_id === 1) {
        if (action === "delete") {
          let { status } = await deleteWorker(worker.worker_id);
          if (status === "ok") {
            addNotification({
              title: "Techforce.ai",
              message: "Your E-Worker Machine has been deleted successfully",
              type: "success",
            });
          }
          reloadProcess();
        } else {
          await updateWorker(worker, action);
          addNotification({
            title: "Techforce.ai",
            message: "Upadated your E-Worker Machine Successfully",
            type: "success",
          });
          reloadProcess();
        }
      } else {
        addNotification({
          title: "Techforce.ai",
          message:
            "You don't have enough permissions to delete E-Worker Machine",
          type: "info",
        });
      }
    } else {
      if (action === "delete") {
        let  data  = await deleteWorker(worker.worker_id);
        if (data.status === "ok") {
          addNotification({
            title: "Techforce.ai",
            message: "Your E-Worker Machine has been deleted successfully",
            type: "success",
          });
        }
        reloadProcess();
      } else {
        await updateWorker(worker, action);
        addNotification({
          title: "Techforce.ai",
          message: `Updated your E-Worker Machine Successfully`,
          type: "success",
        });
        reloadProcess();
      }
    }
  };


  if (workers.length > 0 || loading) {
    if (loading) {
      return (
        <div className="main-content">
          <div className="header-content">
            <label>E-Worker Machines</label>
            <div style={{display:"flex"}}>
              <button className="btn" onClick={handleCreate}>
                {processing ? (
                  <i
                    style={{ fontSize: "15px", color: "#ffffff" }}
                    className="fas fa-circle-notch fa-spin"
                  ></i>
                ) : (
                  "Create"
                )}
              </button>
            </div>
          </div>
          <div style={{ textAlign: "center", marginTop: "15%" }}>
            <img src={loader} width="125" alt="loading"></img>
          </div>
        </div>
      );
    } else {
      return (
        <div className="main-content">
          <div className="header-content">
            <label>E-Worker Machines</label>
            <div style={{display:"flex"}}>
              <button className="btn" onClick={refresh}>
                <i style={{"marginRight":"5px"}} className= "fas fa-redo" ></i>
                Refresh
              </button>
              <button className="btn" onClick={handleCreate}>
                {processing ? (
                  <i
                    style={{ fontSize: "15px", color: "#ffffff" }}
                    className="fas fa-circle-notch fa-spin"
                  ></i>
                ) : (
                  "Create"
                )}
              </button>
            </div>
          </div>
          <div className="content" style={{ height: "75vh" }}>
            <Table hover responsive className="responsive-table">
              <thead>
                <tr>
                  <th>Id</th> 
                  <th>Name</th>
                  <th>Host</th>
                  <th><div>E-Worker Machine Type</div></th>
                  <th><div>Total Usage</div></th>
                  <th><div>Created Date</div></th>
                  <th>Created By</th>
                  <th><div>Worker State</div></th>
                  <th><div>Runtime Status</div></th>
                  {/* <th>Agent</th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody className="table-body">
                {workers.map((obj, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{obj.worker_id}</td>
                      <td>
                        <div>{obj.worker_name}</div>
                      </td>
                      <td>
                        {obj.eworker ? obj.host : (
                          <div>{obj.machine_name ? obj.machine_name : "-"}</div>
                        )}
                      </td>
                      <td>{obj.worker_type}</td>
                      <td>
                        {obj.eworker ? obj.percentage > 100 ? 100+ "%":obj.percentage + "%" : "-"}
                        {/* {obj.machine_name.length > 10 ? (
                          <EllipsisWithTooltip>
                            {obj.machine_name}
                          </EllipsisWithTooltip>
                        ) : (
                          <div>{obj.machine_name ? obj.machine_name : "-"}</div>
                        )} */}
                      </td>
                      <td>
                        {stringToDate(obj.created_at)}
                      </td>
                      <td>
                        {/* {obj.created_by_email.length > 10 ? obj.created_by_email : ( */}
                          <div style={{wordBreak: "break-all"}}>{obj.created_by_email}</div>
                        {/* )} */}
                      </td>
                      <td>
                        <div>
                          {obj.instance_state === "initializing" ? (
                            <i
                              className="fas fa-hourglass-start fa-spin"
                              style={{ color: "blue", marginRight: "10px" }}
                            ></i>
                          ) : null}
                          {obj.instance_state === "running" ? (
                            <i
                              className="fas fa-running"
                              style={{ color: "green", marginRight: "10px" }}
                            ></i>
                          ) : null}
                          {obj.instance_state === "stopped" ? (
                            <i
                              className="fas fa-circle"
                              style={{ color: "red", marginRight: "10px" }}
                            ></i>
                          ) : null}
                          {obj.instance_state ? obj.instance_state : "---"}
                        </div>
                      </td>
                      <td>{ refresh_css?
                            <i className= "fas fa-redo fa-spin"></i>:
                            obj.queue_connection_status?
                            obj.queue_connection_status:"IDLE"
                          }
                      </td>
                      {/* <td>
                      <EllipsisWithTooltip>
                         { obj.agent_uid}
                      </EllipsisWithTooltip>
                      </td> */}
                      <td>
                        {obj.loading ||
                        obj.instance_state === "initializing" ? (
                          <i
                            style={{ color: "#02ce9d" }}
                            className="fas fa-circle-notch fa-spin"
                          ></i>
                        ) : (
                          <Dropdown
                            isOpen={obj.dropdownOpen}
                            toggle={() => handleDropdownOpen(obj)}
                          >
                            <DropdownToggle className="ellipsis-dropdown">
                              <i className="fas fa-ellipsis-v" style={{marginRight:"30px",position:"relative"}}></i>
                            </DropdownToggle>
                            <DropdownMenu
                              style={{ minWidth: "0px", padding: "0px" }}
                              center="true"
                            >
                              {obj.eworker || obj.active ? (
                                <div>
                                  <DropdownItem
                                    className="dropdown-items"
                                    disabled={
                                      obj.instance_state === "running"
                                        ? false
                                        : true
                                    }
                                    onClick={() => toggle(obj, "stop")}
                                  ><i  style={{ color: "#02ce9d",cursor:"pointer",fontSize:"15px",marginRight:"5px"}} className="fas fa-pause-circle"></i>
                                    Stop
                                  </DropdownItem>
                                  <DropdownItem
                                    className="dropdown-items"
                                    disabled={
                                      obj.instance_state === "stopped"
                                        ? false
                                        : true
                                    }
                                    onClick={() => toggle(obj, "start")}
                                  ><i  style={{ color: "#02ce9d",cursor:"pointer",fontSize:"15px",marginRight:"5px"}} className="fas fa-play-circle play"></i>
                                    Start
                                  </DropdownItem>
                                </div>
                              ) : null}
                              <DropdownItem
                                className="dropdown-items"
                                onClick={() => toggle(obj, "delete")}
                              > 
                              <i  style={{ color: "#02ce9d",cursor:"pointer",fontSize:"15px",marginRight:"5px"}} className="fas fa-trash-alt"></i>
                                Delete
                              </DropdownItem>
                              <DropdownItem
                                className="dropdown-items"
                                onClick={() => settingsView(obj, "settings")}>
                                <img src={SettingsIcon} alt="empty Screen" width="15" style={{marginRight:"5px"}}></img>
                                Settings
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          <div>
            {modal ? (
              <CustomModal
                comp={
                  <DeleteWorker
                    worker={worker}
                    action={action}
                    handleDelete={() => handleDelete()}
                    toggle={() => toggle()}
                  />
                }
                name={`${action == "delete" ? "Delete" : action} Worker`} 
                toggle={() => toggle()}
                modal={modal}
              />
            ) : null}
            {
              settings?(
                <CustomModal
                  comp={
                    <SettingsWorker
                      worker={worker}
                      toggle={() => settingsView()}
                    />
                  }
                  name={'Settings'}
                  toggle={() => settingsView()}
                  modal={settings}
                />):null
            }
          </div>
        </div>
      );
    }
  } else {
    return (
      <div className="main-content">
        <div className="header-content">
          <label>E-Worker Machines</label>
        </div>
        <div className="empty-container text-center">
          <img src={EmptyScreen} alt="empty Screen"></img>
          <p>You don't have any E-Worker Machines yet.</p>
          <small>
            Please create an E-Worker Machine on Techforce.ai cloud by clicking
            on Create button or Register your local E-Worker Machine from System
            Tray Menu
          </small>
          <div style={{ marginTop: "10px" }}>
            <button className="btn" onClick={handleCreate}>
              {processing ? (
                <i
                  style={{ fontSize: "15px", color: "#ffffff" }}
                  className="fas fa-circle-notch fa-spin"
                ></i>
              ) : (
                "Create"
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, null)(Workers);
